import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { PENGELOLAAN_KINERJA_BASE_PATH } from 'app/KinerjaShared/constants/path'

import type { KinerjaNotificationListItem } from 'types/kinerja-notification'

export function CardNotificationGeneral({
  data,
  ...cardProps
}: {
  data: KinerjaNotificationListItem
}) {
  const hasHelpCenterUrl = !!data?.contents?.helpCenterUrl
  const hasCustomButtons = data?.contents?.buttons?.length >= 1
  const showButtons = hasCustomButtons || hasHelpCenterUrl

  return (
    <CardNotificationBase
      date={data.date}
      description={data.description}
      title={data.title}
      {...cardProps}
    >
      {showButtons && (
        <div className="flex flex-row items-center gap-6 mt-6">
          {hasCustomButtons &&
            data?.contents?.buttons?.map(({ label, path, ...props }, idx) => (
              <Link
                key={`${data.id}-btn-${idx}`}
                href={`${PENGELOLAAN_KINERJA_BASE_PATH}${path}`}
                passHref
              >
                <Button {...props} as="a">
                  {label}
                </Button>
              </Link>
            ))}

          {!!data?.contents?.helpCenterUrl && (
            <Button
              variant="ghost"
              size="sm"
              as="a"
              href={data?.contents?.helpCenterUrl}
              target="_blank"
            >
              Ke Pusat Bantuan
            </Button>
          )}
        </div>
      )}
    </CardNotificationBase>
  )
}
